import type { SelfSidebarResponseDatagramBuf } from "~/classes/generated/response"

import { DatagramBuf } from "~/classes/generated/datagram"
import { RequestDatagramBuf, SelfSidebarRequestDatagramBuf } from "~/classes/generated/request"
import { DatagramBufferBuilder } from "~/utils/flatbuffers/builder"
import { addRequestIdToBuf, parseDatagramError, parseRequestId } from "~/utils/flatbuffers/datagram"
import { parseUserSidebarItem } from "~/utils/flatbuffers/user"
import { maybe } from "~/utils/helpers"

const console = useLogger("user/info", theme.colors.pink.hex)

export function sendSelfSidebarRequest(request: SelfSidebarRequestDatagram) {
  const { sendWorkerDatagramBuf } = useCache()

  const fbb = new DatagramBufferBuilder(64)
  const requestId = addRequestIdToBuf(fbb, request.requestId)
  SelfSidebarRequestDatagramBuf.startSelfSidebarRequestDatagramBuf(fbb)
  SelfSidebarRequestDatagramBuf.addRequestId(fbb, requestId)
  SelfSidebarRequestDatagramBuf.addOffline(fbb, request.offline)
  const infoRequest = SelfSidebarRequestDatagramBuf.endSelfSidebarRequestDatagramBuf(fbb)

  RequestDatagramBuf.startRequestDatagramBuf(fbb)
  RequestDatagramBuf.addSelfSidebarRequest(fbb, infoRequest)
  const requests = DatagramBuf.createRequestVector(fbb, [RequestDatagramBuf.endRequestDatagramBuf(fbb)])
  DatagramBuf.startDatagramBuf(fbb)
  DatagramBuf.addRequest(fbb, requests)
  fbb.finish(DatagramBuf.endDatagramBuf(fbb))
  sendWorkerDatagramBuf(fbb.asUint8Array())
}

export function handleSelfSidebarResponseDatagramBuf(datagram: SelfSidebarResponseDatagramBuf) {
  const sidebarItems: Record<string, UserSidebarItem> = {}

  for (const i of range(datagram.sidebarItemsLength())) {
    const item = parseUserSidebarItem(datagram.sidebarItems(i)!)
    sidebarItems[item.fractionalIndex] = item
  }

  onSelfSidebarResponseDatagram({
    requestId: parseRequestId(datagram.requestId()!),
    offline: datagram.offline(),
    error: maybe(parseDatagramError)(datagram.error()),
    sidebarItems,
  })
}

export function onSelfSidebarResponseDatagram(response: SelfSidebarResponseDatagram) {
  const { emitInterfaceEvent, emitEntityEvent } = useEvents()
  emitInterfaceEvent("selfSidebarResponse", response, response.requestId)

  if (response.error || response.sidebarItems === undefined)
    return console.error("Self sidebar request failed", response)

  for (const item of Object.values(response.sidebarItems)) {
    if (item.fileItem)
      emitEntityEvent("fileProperties", item.fileItem.id, item.fileItem, response.offline)
    else if (item.searchItem)
      emitEntityEvent("searchProperties", item.searchItem.id, item.searchItem, response.offline)
    else if (item.conversationItem)
      emitEntityEvent("conversationProperties", item.conversationItem.id, item.conversationItem, response.offline)
  }
}
